export default {
  favoriteToggle: 'toggle_video_favorite',
  rateToggle: 'toggle_video_rate',
  videoRating: 'video_rating',
  videoId: 'video_id'
}
